import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import classNames from "classnames";
import { colorClassNamesLabelMap, colorClassNamesMap, ListingStateColorMapStyles } from "components/ListingStateColorMap/ListingStateColorMap";
import { Typography, withStyles, RaiseColors, Chip } from "components/mui";
import { BadgeTypeEnum } from "componentLibrary";
import React from "react";
import { ListingStateEnum } from "utils/Enums";
import ListingStateChipFragment from "./ListingStateChipFragment";
import { jsx as _jsx } from "react/jsx-runtime";
var styles = function styles(theme) {
  return _objectSpread({
    listingStateChip: {
      height: "20px",
      marginTop: "4px",
      marginBottom: "4px"
    }
  }, ListingStateColorMapStyles(theme));
};
var inLeasesValues = [ListingStateEnum.IN_LEASES.value];
var getLabel = function getLabel(_ref) {
  var listing = _ref.listing,
    doCombineInleases = _ref.doCombineInleases;
  var listingState = listing.listingState;
  if (listingState === "") {
    return ListingStateEnum.NOT_AVAILABLE.value;
  }
  if (doCombineInleases && _indexOfInstanceProperty(inLeasesValues).call(inLeasesValues, listingState) !== -1) {
    return ListingStateEnum.IN_LEASES.label;
  }
  return _valuesInstanceProperty(ListingStateEnum)[listingState].label;
};
var getColorClass = function getColorClass(_ref2) {
  var listingState = _ref2.listing.listingState,
    classes = _ref2.classes,
    _ref2$labelOnly = _ref2.labelOnly,
    labelOnly = _ref2$labelOnly === void 0 ? false : _ref2$labelOnly;
  return classes[labelOnly ? colorClassNamesLabelMap[listingState] : colorClassNamesMap[listingState]];
};
var getBadgeType = function getBadgeType(listingState) {
  switch (listingState) {
    case ListingStateEnum.PREDICTED.value:
      return BadgeTypeEnum.amber;
    case ListingStateEnum.ON_MARKET.value:
      return BadgeTypeEnum.success;
    case ListingStateEnum.IN_PROPOSALS.value:
      return BadgeTypeEnum.lilac;
    case ListingStateEnum.IN_LEASES.value:
      return BadgeTypeEnum.royal;
    case ListingStateEnum.LEASED.value:
      return BadgeTypeEnum.destructive;
    case ListingStateEnum.DEAD.value:
      return BadgeTypeEnum.neutral;
    case ListingStateEnum.NOT_AVAILABLE.value:
      return BadgeTypeEnum.neutral;
    default:
      return BadgeTypeEnum.neutral;
  }
};
var ListingStateChip = function ListingStateChip(_ref3) {
  var listing = _ref3.listing,
    classes = _ref3.classes,
    className = _ref3.className,
    doCombineInleases = _ref3.doCombineInleases,
    _ref3$labelOnly = _ref3.labelOnly,
    labelOnly = _ref3$labelOnly === void 0 ? false : _ref3$labelOnly;
  if (labelOnly) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_xsmall",
      weight: "bold",
      className: classNames(className, classes.listingStateChip, getColorClass({
        listing: listing,
        classes: classes,
        labelOnly: labelOnly
      })),
      children: getLabel({
        listing: listing,
        doCombineInleases: doCombineInleases
      })
    });
  }
  var label = getLabel({
    listing: listing,
    doCombineInleases: doCombineInleases
  });
  var type = getBadgeType(listing === null || listing === void 0 ? void 0 : listing.listingState);
  return /*#__PURE__*/_jsx(Chip, {
    className: classNames(className, classes.listingStateChip, getColorClass({
      listing: listing,
      classes: classes
    })),
    label: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_xsmall",
      color: RaiseColors.white,
      children: getLabel({
        listing: listing,
        doCombineInleases: doCombineInleases
      })
    })
  });
};
ListingStateChip.fragments = {
  listing: ListingStateChipFragment
};
export default withStyles(styles)(ListingStateChip);